import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'
const UPDATE_INVITING = 'orgamax/collaboration/inviting/UPDATE_INVITING'
const INVITING_LOADING = 'orgamax/collaboration/inviting/INVITING_LOADING'
const INVITING_ERROR = 'orgamax/collaboration/inviting/INVITING_ERROR'

/*
 * Reducer
 */
const initialState = {
  data: {},
  isLoading: false,
  isInitialized: false,
  errorOccurred: false,
  error: undefined,
}

export default function reducer(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case UPDATE_INVITING:
      return { ...state, isLoading: false, data, error: undefined, errorOccurred: false, isInitialized: true }

    case INVITING_LOADING:
      return { ...state, isLoading: true, error: undefined, errorOccurred: false }

    case INVITING_ERROR:
      return { ...state, errorOccurred: true, error: data }

    default:
      return state
  }
}

const updateData = (data) => {
  return {
    type: UPDATE_INVITING,
    data,
  }
}

const setLoading = () => {
  return {
    type: INVITING_LOADING,
  }
}

const setError = (error) => {
  return {
    type: INVITING_LOADING,
    data: error,
  }
}

export const fetchInvitingTenants = () => {
  return async dispatch => {
    dispatch(setLoading())

    try {
      request(config.getInvitingTenants, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          dispatch(updateData(data))
        })
        .catch(error => dispatch(setError(error)))
    } catch (error) {
      dispatch(setError(error))
    }
  }
}
